var exports = {
  "kL": "container-Ym5DT",
  "oq": "authContainer-Ym5DT",
  "KJ": "formContainer-Ym5DT",
  "wx": "header-Ym5DT",
  "jB": "headerForget-Ym5DT",
  "QL": "inputs-Ym5DT",
  "We": "buttonArea-Ym5DT",
  "V2": "failure-Ym5DT",
  "J1": "submitRow-Ym5DT",
  "tA": "submit-Ym5DT",
};

module.exports = exports;
